const cart =
    {
        getItems() {
            let cart = JSON.parse(localStorage.getItem('cart'));
            if (cart == null) {
                cart = [];
            }
            return cart;
        },

        getItemsCount(){
            let count = 0;
            for(let item of this.getItems()){
                count += item.Count;
            }
            return count;
        },

        addItem(rewardId, priceId, rewardType, price, addressId) {
            //console.info('[rewardId, priceId, rewardType, addressId]', [rewardId, priceId, rewardType, addressId])
            let cart = this.getItems();
            // let item = cart.find(x => {
            //     return x.Id === rewardId && x.PriceId === priceId;
            // });
            // if (item === undefined || rewardType === 1 || rewardType === 2) {
            //     cart.push({Id: rewardId, PriceId: priceId, Count: 1});
            // } else {
            //     item.Count += 1;
            // }
            cart.push({Id: rewardId, PriceId: priceId, Count: 1, Price: price, AddressId: addressId});

            this.saveCart(cart);
        },

        removeItem(id){
            let cart = this.getItems();

            for(let i = 0; i < cart.length; i++){
                if(cart[i].Id === id){
                    cart.splice(i, 1);
                    break;
                }
            }

            this.saveCart(cart);
        },

        updateItemCount(cartItem){
            let cart = this.getItems();

            let item = cart.find(x => { return x.Id === cartItem.Id && x.PriceId === cartItem.PriceId; });
            if(item !== undefined){
                item.Count = cartItem.Count;
                this.saveCart(cart);
            }
        },

        saveCart(cart) {
            localStorage.setItem('cart', JSON.stringify(cart));
        }
    };

export default cart;


// WEBPACK FOOTER //
// ./Content/src/cart.js